import React, { useEffect, useState } from 'react';
import {
  Box, Button, Divider, ListItemText, MenuItem, MenuList, Popover, Stack, TextField, Typography,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import * as actions from '../../../../redux/actions';
import { TYPE_LABELS, TYPE_OPTIONS } from '../../constants/type';

// คลิกขวาเลือก Type ตรงๆ ในตาราง ไม่ต้องเปิด CellEditModal เต็มรูปแบบ (เหมือน
// BudgetApproveMenu.js) — ยกเว้น "Other" ที่ต้องพิมพ์ระบุเพิ่ม ใช้ popover เดียวกันสลับหน้า (เลือก
// ประเภท ↔ กรอกชื่อ Other) แทนการเด้ง modal แยก ไม่ปิด popover ระหว่างสลับหน้า ปิดแค่ตอนบันทึกจริง
// หรือกดปิดเอง — anchorReference="anchorPosition" กันเมนูเด้งผิดที่ถ้าแถวหลุดจาก filter ระหว่าง
// เปิดอยู่ (เหตุผลเดียวกับ BudgetApproveMenu.js/Dim3Popover เดิม)
export default function TypeMenu({ target, onClose, onSaved }) {
  const dispatch = useDispatch();
  const [otherMode, setOtherMode] = useState(false);
  const [otherText, setOtherText] = useState('');

  useEffect(() => {
    if (target) {
      setOtherMode(false);
      setOtherText(target.row?.type === 'OTHER' ? (target.row?.type_other || '') : '');
    }
  }, [target]);

  const save = async (type, typeOtherValue) => {
    const row = target?.row;
    onClose();
    if (!row) return;
    await dispatch(actions.updateOpportunity({
      id: row.id,
      type: type || undefined,
      typeOther: type === 'OTHER' ? (typeOtherValue || undefined) : undefined,
    }));
    onSaved?.();
  };

  const handlePick = (value) => {
    if (value === 'OTHER') {
      setOtherMode(true);
      return;
    }
    save(value, undefined);
  };

  const handleSaveOther = () => {
    if (!otherText.trim()) return;
    save('OTHER', otherText.trim());
  };

  return (
    <Popover
      open={!!target}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={target ? { top: target.mouseY, left: target.mouseX } : undefined}
    >
      {otherMode ? (
        <Box sx={{ p: 2, width: 260 }}>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
            ระบุประเภทงาน (Other)
          </Typography>
          <TextField
            autoFocus
            fullWidth
            size="small"
            value={otherText}
            onChange={(e) => setOtherText(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') handleSaveOther(); }}
          />
          <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ mt: 1.5 }}>
            <Button size="small" onClick={() => setOtherMode(false)}>ย้อนกลับ</Button>
            <Button size="small" variant="contained" disabled={!otherText.trim()} onClick={handleSaveOther}>
              บันทึก
            </Button>
          </Stack>
        </Box>
      ) : (
        <MenuList dense sx={{ minWidth: 180 }}>
          <MenuItem onClick={() => handlePick('')} selected={!target?.row?.type}>
            <ListItemText>ยังไม่ระบุ</ListItemText>
          </MenuItem>
          <Divider />
          {TYPE_OPTIONS.map((t) => (
            <MenuItem key={t} onClick={() => handlePick(t)} selected={target?.row?.type === t}>
              <ListItemText>{TYPE_LABELS[t]}</ListItemText>
            </MenuItem>
          ))}
        </MenuList>
      )}
    </Popover>
  );
}
